<div class="row" *ngIf="inspection">
  <inspection-edit
    [inspection]="inspection"
    [processing]="processing"
    [statusList]="statusList"
    [categories]="categories"
    (toggleSaveInspection)="saveInspection($event)"
    (toggleCancel)="cancel()"
  ></inspection-edit>
</div>
